import React from 'react';
import { Pin, Star, GitFork, GripVertical } from 'lucide-react';
import { Card } from './ui/Card';
import { Badge } from './ui/Badge';
interface Service {
  name: string;
  description: string;
  tech: string;
  color: string;
  stars: number;
  forks: number;
  isPublic: boolean;
}
const services: Service[] = [{
  name: 'web-development',
  description: 'Modern frontend and backend solutions using React, Node.js, and Next.js.',
  tech: 'TypeScript',
  color: '#3178c6',
  stars: 84,
  forks: 12,
  isPublic: true
}, {
  name: 'mobile-applications',
  description: 'Native and cross-platform mobile apps for iOS and Android.',
  tech: 'Swift',
  color: '#F05138',
  stars: 42,
  forks: 8,
  isPublic: true
}, {
  name: 'cloud-infrastructure',
  description: 'Scalable cloud architecture, serverless functions, and database management.',
  tech: 'HCL',
  color: '#5F43E9',
  stars: 156,
  forks: 24,
  isPublic: true
}, {
  name: 'api-development',
  description: 'RESTful and GraphQL API design with robust security and documentation.',
  tech: 'Go',
  color: '#00ADD8',
  stars: 93,
  forks: 18,
  isPublic: true
}, {
  name: 'ui-ux-design',
  description: 'User-centered design systems, prototyping, and interface creation.',
  tech: 'CSS',
  color: '#563d7c',
  stars: 215,
  forks: 45,
  isPublic: true
}, {
  name: 'devops-cicd',
  description: 'Automated testing, deployment pipelines, and infrastructure as code.',
  tech: 'Shell',
  color: '#89e051',
  stars: 67,
  forks: 14,
  isPublic: true
}];
export function PinnedServices() {
  return <section className="py-8" id="services" data-id="element-145">
      <div className="flex items-center justify-between mb-4" data-id="element-146">
        <h2 className="text-sm font-semibold text-[#24292f] flex items-center gap-2" data-id="element-147">
          <Pin size={16} className="text-[#57606a]" data-id="element-148" />
          Pinned Services
        </h2>
        <button className="text-xs text-[#0969da] hover:underline" data-id="element-149">
          Customize your pins
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-150">
        {services.map(service => <Card key={service.name} hoverEffect className="flex flex-col h-full min-h-[140px]" data-id="element-151">
            <div className="flex items-center justify-between mb-2" data-id="element-152">
              <div className="flex items-center gap-2" data-id="element-153">
                <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" className="fill-[#57606a]" data-id="element-154">
                  <path d="M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5Zm10.5-1h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9h8ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2Z" data-id="element-155"></path>
                </svg>
                <a href="#" className="font-bold text-[#0969da] hover:underline truncate" data-id="element-156">
                  {service.name}
                </a>
                <span className="px-1.5 py-0.5 rounded-full border border-[#d0d7de] text-[10px] font-medium text-[#57606a]" data-id="element-157">
                  Public
                </span>
              </div>
              <GripVertical size={14} className="text-[#d0d7de] cursor-grab opacity-0 group-hover:opacity-100" data-id="element-158" />
            </div>

            <p className="text-xs text-[#57606a] mb-4 flex-grow line-clamp-3" data-id="element-159">
              {service.description}
            </p>

            <div className="flex items-center gap-4 text-xs text-[#57606a] mt-auto" data-id="element-160">
              <Badge color={service.color} data-id="element-161">{service.tech}</Badge>
              <div className="flex items-center gap-1 hover:text-[#0969da] cursor-pointer" data-id="element-162">
                <Star size={14} data-id="element-163" />
                {service.stars}
              </div>
              <div className="flex items-center gap-1 hover:text-[#0969da] cursor-pointer" data-id="element-164">
                <GitFork size={14} data-id="element-165" />
                {service.forks}
              </div>
            </div>
          </Card>)}
      </div>
    </section>;
}